import { border, lodestarColors, motion, space, typography, ursaColors } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
import { ANIMATION_DURATION } from "./tooltipConstants";
export var tooltipTheme = themed({
  background: {
    "lodestar-light": lodestarColors.tooltipBackground,
    "ursa-light": ursaColors.slate700
  },
  borderRadius: {
    "lodestar-light": border.radius05,
    "ursa-light": border.radius10
  },
  textColor: {
    body: {
      "lodestar-light": lodestarColors.neutralLight30,
      "ursa-light": ursaColors.slate25
    },
    title: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: lodestarColors.neutralLight30,
      "ursa-light": ursaColors.slate25
    }
  },
  fontSize: {
    // Yay these are all the same.
    basic: typography.fontSize.size20,
    multiLineTitle: {
      "lodestar-light": "13px",
      "ursa-light": typography.fontSize.size30
    },
    multiLine: {
      "lodestar-light": "13px",
      "ursa-light": typography.fontSize.size20
    },
    multilineTitleDeprecated: {
      "lodestar-light": "13px",
      "ursa-light": typography.fontSize.size30
    }
  },
  fontWeight: {
    body: typography.fontWeight.regular,
    title: typography.fontWeight.semiBold
  },
  lineHeight: {
    body: {
      "lodestar-light": typography.lineHeight.size30,
      "ursa-light": typography.lineHeight.size20
    },
    title: typography.lineHeight.size30
  },
  padding: {
    body: {
      "lodestar-light": "3px 8px",
      "ursa-light": space.space30
    },
    // These styles are from the old Lodestar version that didn't use the TooltipBody so these
    // components provided all the necessary padding.
    multiLineDeprecated: {
      title: {
        "lodestar-light": "".concat(space.space20, " ").concat(space.space40, " ").concat(space.space10),
        "ursa-light": "".concat(space.space30, " ").concat(space.space30, " ").concat(space.space10)
      },
      subtext: {
        "lodestar-light": "0 ".concat(space.space40, " ").concat(space.space30),
        "ursa-light": "0 ".concat(space.space30, " ").concat(space.space30)
      },
      subtextShift: {
        "lodestar-light": "-8px",
        "ursa-light": "-4px"
      }
    },
    // These styles require the TooltipBody to wrap the components that use them.
    multiLine: {
      title: {
        "lodestar-light": "9px ".concat(space.space20, " ").concat(space.space10),
        "ursa-light": "0 0 ".concat(space.space10)
      },
      text: {
        "lodestar-light": "0 ".concat(space.space20),
        "ursa-light": "0"
      },
      // The distance between tooltip text siblings. The title has the gap between title and
      // text.
      textGap: {
        "lodestar-light": space.space10,
        "ursa-light": space.space20
      },
      textEndGap: {
        // This is the special gap added to get the right padding-bottom in the Lodestar
        // version of the multiline tooltip.
        "lodestar-light": "9px",
        "ursa-light": "0"
      }
    }
  },
  motion: {
    slide: {
      "lodestar-light": "".concat(ANIMATION_DURATION, "ms cubic-bezier(0.23, 1, 0.32, 1)"),
      "ursa-light": motion.animation.default
    },
    opacity: {
      "lodestar-light": "".concat(ANIMATION_DURATION / 2, "ms"),
      "ursa-light": motion.animation.default
    }
  }
});
export var getTooltipMultilineTitleTypeRampProps = function getTooltipMultilineTitleTypeRampProps(themeMode) {
  switch (themeMode) {
    case "ursa-light":
      return {
        system: "ursa",
        variant: "Inter--14px--600w"
      };
    case "lodestar-light":
    case "oldestar":
    default:
      return {
        system: "lodestar",
        variant: "headerSmall"
      };
  }
};
//# sourceMappingURL=tooltipTheme.js.map